let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h9Obz")).then(() => parcelRequire('bXN1r'));